import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, SectionTitle } from '../ui';
import { savePref } from '../prefs';

export const PDF_COVERS = [['a', 'Classica'], ['b', 'Executive scura'], ['c', 'Fascia laterale']];

export default function CoverPreference() {
  const [cover, setCover] = useState(() => localStorage.getItem('bond_pdf_cover') || 'a');
  const pick = (v) => { savePref('pdf_cover', v); setCover(v); };
  const [graph, setGraph] = useState(() => localStorage.getItem('bond_pdf_graph') === '1');
  const toggleGraph = (v) => { savePref('pdf_graph', v); setGraph(v); };
  return (
    <Card className="p-8 mt-4" data-testid="cover-preference">
      <SectionTitle>Copertina dei report PDF</SectionTitle>
      <p className="text-sm text-[#8A8F97] mb-6">Scegli lo stile della prima pagina dei tuoi report. Puoi cambiarlo anche al momento del download. Le scelte sono salvate sul tuo profilo e valgono su ogni dispositivo.</p>
      <div className="grid grid-cols-3 gap-4 max-w-2xl">
        {PDF_COVERS.map(([v, label]) => (
          <button key={v} onClick={() => pick(v, label)} data-testid={`cover-option-${v}`}
            className={`text-left border rounded-sm p-2 transition-colors ${cover === v ? 'border-[#D4AF37]' : 'border-[#1F242C] hover:border-[#3A3F47]'}`}>
            <img src={`/samples/cover_${v.toUpperCase()}.png`} alt={`Copertina ${label}`} className="w-full aspect-[1/1.414] object-cover bg-white" />
            <span className="flex items-center gap-2 text-xs mt-2 text-[#C9CCD1]">
              {cover === v && <CheckCircle2 size={13} className="text-[#D4AF37]" />}{label}
            </span>
          </button>
        ))}
      </div>
      <label className="flex items-center gap-3 mt-6 text-sm text-[#C9CCD1] cursor-pointer w-fit" data-testid="pref-graph-toggle">
        <input type="checkbox" checked={graph} onChange={(e) => toggleGraph(e.target.checked)} className="accent-[#D4AF37] w-4 h-4" data-testid="pref-graph-checkbox" />
        Includi nel PDF il grafo delle relazioni (soci, dirigenti, gruppo)
      </label>
    </Card>
  );
}
